<template>
  <div class="pdfDemo">
    <v-pdf :pdfUrl="pdfUrl"></v-pdf>
  </div>
</template>

<script>
import pdf from '@/components/pdf'
export default {
  data () {
    return {
      pdfUrl: window.baseapi.baseUrl + this.$route.query.videoObj.file_path
      // pdfUrl: 'static/test.pdf' // pdf url地址
    }
  },
  components: {
    'v-pdf': pdf
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pdfWatcher.vue